import TrainerCard, { TrainerCardSkeleton } from '@/components/common/Trainer/TrainerCard';
import { GET_TRAINER_RANDOM_LIST } from '@/Graphql/queries';
import { getRoutes } from '@/routes/routePaths';
import { useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';

const LIMIT = 6;

const TrainerList = () => {
  const { data, loading } = useQuery(GET_TRAINER_RANDOM_LIST, {
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  });
  return (
    <div className='w-full  flex flex-col overflow-auto gap-4 pt-3'>
      <div className='flex w-full items-center justify-between gap-2'>
        <h2 className='text-xl font-bold'>Meet our Trainers</h2>
        <Link className='text-xs' to={getRoutes.Trainers}>
          View All
        </Link>
      </div>
      <div className='h-full'>
        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4'>
          {loading
            ? Array.from({ length: LIMIT }).map((_, i) => <TrainerCardSkeleton key={i} />)
            : data?.meetOurTrainers?.map((trainer, i) => {
                if (trainer && i < 6) {
                  return <TrainerCard key={i} trainer={trainer} />;
                }
              })}
        </div>
      </div>
    </div>
  );
};

export default TrainerList;
